import React, { useEffect, useState } from "react";
import {useDispatch, useSelector} from "react-redux";
import { Formik, Field, Form } from "formik";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading";
import { ModifierLanguageSelect } from "./ModifierLanguageSelect";
import { onCompanySettingListsLoad } from "../../store/Settings/actions";

// const languages = [
//     { value: "am", label: "Armenian" },
//     { value: "eng", label: "English" },
//     { value: "ru", label: "Russian" },
// ]

export const Language = ({ loading, modifier, itemId }) => {
    const [data, setData] = useState({
        language: "",
        category: "",
        items: [],
    });

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {dispatch(onCompanySettingListsLoad())}, []);

    const { languages_list } = useSelector(({settings}) => ({
            languages_list: settings.company_setting_lists.languages_list,
        }));

    useEffect(() => {
        if(itemId){
          let items = modifier.data.modifier_items
                ? modifier.data.modifier_items.map((item) => ({
                      id: item.id,
                      name: item.name ?? "",
                  }))
                : [];
            setData((prevState) => (
                { ...prevState, category : modifier?.data.name || "", items }))
        }
    }, [modifier, itemId]);

    const handleSubmit = async (values) => {
        // dispatch(onModifierLanguageSave(values));
    }

    return (
        <Loading loading={loading}>
            <Formik
                enableReinitialize
                onSubmit={handleSubmit}
                initialValues={data}
            >
                {() => (
                    <Form>
                        <div className="rounded-lg shadow-md bg-white pt-2 px-5" style={{ minHeight: "60vh" }}>
                            <p className="my-2 text-xl font-bold">{t("Languages")}</p>

                            <div className="mr-48 pt-2 pb-4 font-medium text-sm">
                                {t(
                                    "Your current default language is Armenian. Please add/edit and save your menu item names and descriptions in the supported languages (English and Russian). Your customers will then be able to switch language settings on your app."
                                )}
                            </div>

                            <div className="w-5/12">
                                <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                                    <label
                                        htmlFor="language"
                                        className="block text-sm font-bold text-black-800 mb-1"
                                    >
                                        {t("Choose Language")}
                                    </label>
                                    <Field
                                        name="language"
                                        component={ModifierLanguageSelect}
                                        options={languages_list}
                                    />
                                </div>

                                <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                                    <label
                                        htmlFor="category"
                                        className="block text-sm font-bold text-black-800"
                                    >
                                        {t("Category")}
                                    </label>

                                    <Field
                                        type="text"
                                        name="category"
                                        placeholder={t("Category")}
                                        className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                    />
                                </div>

                                {data.items.map(item=>(
                                    <div key={item.id} className="col-span-3 sm:col-span-3 py-1 mb-1">
                                        <label
                                            htmlFor={`${item.id}`}
                                            className="block text-sm font-bold text-black-800"
                                        >
                                            {t(`Name - ${item.name}`)}
                                        </label>

                                        <Field
                                            type="text"
                                            name={`${item.id}`}
                                            placeholder={t("Name")}
                                            className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                        />
                                    </div>
                                ))}

                                <div className="py-3 text-right">
                                    <button
                                        type="submit"
                                        className="inline-flex justify-center py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                                    >
                                        {t("Save")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Loading>
    );
};
